export const MIN_ZOOM = 0.2;
export const MAX_ZOOM = 1.0;
